import React from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import CredfinFavicon from '../images/credfinfav.jpeg'
import AbhicashFavicon from '../images/AbhicashFav.png'
import CredfinLogo from '../images/credfinlogo.png'
import AbhicashLogo from '../images/AbhicashLogo.png'
import CredfinLightLogo from '../images/credfin.png'
import creditJarLogoDark from '../images/creditJarLogo.svg'
import creditjarFavicon from '../images/creditjarFavicon.svg'
import creditjarFaviconLight from '../images/creditjarFaviconLight.svg'
import cashbridgeDarLogo from '../images/cashbridgeDarLogo.svg'
import cashbridgeFavicon from '../images/cashbridgeFavicon.svg'
import cashbridgeLightLogo from '../images/cashbridgeLightLogo.svg'
import cashbridgeLogo2 from '../images/cashbridgelogo.svg'
import DsFinanceLogo from '../images/DsFinanceLogo.svg' 
import dsFinanceFav from '../images/dsFinanceFav.webp'
import wogomLogo from '../images/wogomLogo.svg'

const TENANT_CONFIGS = {
  'admin.credfin.money': {
    COMPANY_NAME: "Credfin",
    COMPANY_NAME_CAPS: "CREDFIN",
    COMPANY_NAME_SMALLCASE: "credfin",
     FINANCE_URL:"https://finance.infitouch.in/",
    BASE_URL: 'https://backend.credfin.money/',
    FRONTEND_BASE_URL: 'https://admin.credfin.money/',
     LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'cf',
    ESIGN_KEY: "arhamfinance&investmentservicesltd_esign_live",
    WEB_URL: 'https://admin.credfin.money/',
    TITLE: "Loans made Easy",
    FAVICON: CredfinFavicon,
    LOGO: CredfinLogo,
    LIGHT_LOGO: CredfinLightLogo,
    HEADER_LOGO_WIDTH: "80px",
    RootcssClassName: "credfin-css",
    BOSS_EMAILID: "mohit.bansal@credfin.money",
    NBFC_NAME_TO_SHOW: "Arham",
    REPORT_DB_KEY: "credfin",
    ADMIN_URL_STRING_SHORT :"credfin.money",
    ADMIN_URL_STRING_SHORT_FULL_URL :"admin.credfin.money",
    NBFC_SHORT:"Arham",
    WEBSITE_URL:"https://credfin.money",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : Arham Finance and Investment Services Ltd',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : 112, DAYANAND ROAD, DARYAGANJ, NEW DELHI-11,NEWDELHI,110002',
      ACCOUNT_NUMBER: 'A/C : 033305006690',
      IFSC_CODE: 'ifsc code : ICIC0000333',
      NBFC_NAME:"Arham Finance and Investment Services Ltd",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.credfin.money/uploadDocuments/",
      MOBILE_NO: "+91-9311226661",
      EMAIL_ID: "recovery@credfin.money",
      FINANCE_MAIL_ID: "finance@credfin.money",
      SUPPORT_MAIL_ID: "support@credfin.money",
      KYC_URL: 'https://admin.crefin.money/kyc/',
      CONFIG_MAIL_ID: "config@credfin.money",
      RECOVERY_MAIL_ID:"recovery@credfin.money",
      APP_LINK:"app.credfin.money/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"Credfin Infotech Pvt. Ltd.",
      ADDRESS:"1401,1403, Building No. 43, Chiranjiv Tower",
      AREA:"Opposite Eros Hotel, Nehru Place",
      CITY :"New Delhi- 110019."
    }

  },
  'admin.abhicash.in': {
    COMPANY_NAME: "Abhicash",
    COMPANY_NAME_CAPS: "ABHICASH",
    COMPANY_NAME_SMALLCASE: "abhicash",
     FINANCE_URL:"https://finance.infitouch.in/",
    BASE_URL: 'https://backend.abhicash.in/',
    FRONTEND_BASE_URL: 'https://admin.abhicash.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'ac',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.abhicash.in/',
    TITLE: "Instant Loans and Financial Wellness Solutions",
    FAVICON: AbhicashFavicon,
    LOGO: AbhicashLogo,
    LIGHT_LOGO: AbhicashLogo,
     HEADER_LOGO_WIDTH: "80px",
    RootcssClassName: "Abhicash-css",
    BOSS_EMAILID: "mohit.bansal@abhicash.in",
    NBFC_NAME_TO_SHOW: "CNMP",
    REPORT_DB_KEY: "abhicash",
    ADMIN_URL_STRING_SHORT :"abhicash.in",
    ADMIN_URL_STRING_SHORT_FULL_URL :"admin.abhicash.in",
     NBFC_SHORT:"CNMP",
     WEBSITE_URL:"https://abhicash.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : CNMP Investments Private Limited',
      BANK_NAME: 'Bank : HDFC, Delhi',
      BRANCH_NAME: 'Branch : CONNAUGHT PLACE',
      ACCOUNT_NUMBER: 'A/C : 50200072791180',
      IFSC_CODE: 'ifsc code : HDFC0001563',
      NBFC_NAME:"CNMP Investments Private Limited",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.abhicash.in/uploadDocuments/",
      // MOBILE_NO: "+91-9220320064",
      MOBILE_NO: "08047861605",
      EMAIL_ID: "recovery@abhicash.in",
      FINANCE_MAIL_ID: "finance@abhicash.in",
      SUPPORT_MAIL_ID: "support@abhicash.in",
      KYC_URL: 'https://admin.abhicash.in/kyc/',
      CONFIG_MAIL_ID: "config@abhicash.in",
      RECOVERY_MAIL_ID:"recovery@abhicash.in",
      APP_LINK:"app.abhicash.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"Abhicash Infotech Pvt. Ltd.",
      ADDRESS:"410, Enkay Center, Vanijya Nikunj,",
      AREA:"WING A, Plot No A, Udyog Vihar, Phase-V,",
      CITY :"Gurugram, Haryana-122016"
    }

  },
  'admin.creditjar.in': {
    COMPANY_NAME: "Creditjar",
    COMPANY_NAME_CAPS: "CREDITJAR",
    COMPANY_NAME_SMALLCASE: "creditjar",
     FINANCE_URL:"https://finance.infitouch.in/",
    BASE_URL: 'https://backend.creditjar.in/',
    FRONTEND_BASE_URL: 'https://admin.creditjar.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'cj',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.creditjar.in/',
    TITLE: "Get quick, hassle-free funds Designed to meet urgent needs",
    FAVICON: creditjarFavicon,
    LOGO: creditJarLogoDark,
    LIGHT_LOGO: creditJarLogoDark,
     HEADER_LOGO_WIDTH: "100px",
    RootcssClassName: "Creditjar-css",
    BOSS_EMAILID: "mohit.bansal@creditjar.in",
    NBFC_NAME_TO_SHOW: "D.S. Integrated",
    REPORT_DB_KEY: "creditjar",
    ADMIN_URL_STRING_SHORT :"creditjar.in",
    ADMIN_URL_STRING_SHORT_FULL_URL :"admin.creditjar.in",
     NBFC_SHORT:"D.S. Integrated",
     WEBSITE_URL:"https://creditjar.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : D.S.INTEGRATED FINSEC PRIVATE LIMITED ',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : RAJKOT - GONDAL ROAD',
      ACCOUNT_NUMBER: 'A/C : 072805003919',
      IFSC_CODE: 'ifsc code : ICIC0000728',
      NBFC_NAME:"D.S. Integrated Finsec Private Limited",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.creditjar.in/uploadDocuments/",
      // MOBILE_NO: "+91-9220320064",
      MOBILE_NO: "9876543219",
      EMAIL_ID: "recovery@Creditjar.in",
      FINANCE_MAIL_ID: "finance@Creditjar.in",
      SUPPORT_MAIL_ID: "support@Creditjar.in",
      KYC_URL: 'https://admin.creditjar.in/kyc/',
      CONFIG_MAIL_ID: "config@Creditjar.in",
      RECOVERY_MAIL_ID:"recovery@Creditjar.in",
      APP_LINK:"app.Creditjar.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"D.S. Integrated Finsec Private Limited",
      ADDRESS:"OPP ANDH MAHILA VIKAS GRUH, ARIHANT,SHRAMJIVI SOCIETY,",
      AREA:" DHEBAR ROAD, RAJKOT,",
      CITY :"Rajkot, Gujarat, 360002"
    }

  },
  'admin.cashbridge.in': {
    COMPANY_NAME: "Cashbridge",
    COMPANY_NAME_CAPS: "CASHBRIDGE",
    COMPANY_NAME_SMALLCASE: "cashbridge",
     FINANCE_URL:"https://finance.infitouch.in/",
    BASE_URL: 'https://backend.cashbridge.in/',
    FRONTEND_BASE_URL: 'https://admin.cashbridge.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'cb',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.cashbridge.in/',
    TITLE: "Get quick, hassle-free funds Designed to meet urgent needs",
    FAVICON: cashbridgeFavicon,
    LOGO: cashbridgeLogo2,
    LIGHT_LOGO: cashbridgeLogo2,
     HEADER_LOGO_WIDTH: "120px",
    RootcssClassName: "Cashbridge-css",
    BOSS_EMAILID: "mohit.bansal@cashbridge.in",
    NBFC_NAME_TO_SHOW: "Rachit Capital Services",
    REPORT_DB_KEY: "cashbridge",
    ADMIN_URL_STRING_SHORT :"cashbridge.in",
    ADMIN_URL_STRING_SHORT_FULL_URL :"admin.cashbridge.in",
     NBFC_SHORT:"Rachit Capital Services",
     WEBSITE_URL:"https://cashbridge.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : Rachit Capital Services Private limited',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : GURGAON - SECTOR 14',
      ACCOUNT_NUMBER: 'A/C : 002105030854',
      IFSC_CODE: 'ifsc code : ICIC0000021',
      NBFC_NAME:"Rachit Capital Services Privated Limited",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.cashbridge.in/uploadDocuments/",
      // MOBILE_NO: "+91-9220320064",
      MOBILE_NO: "9876543219",
      EMAIL_ID: "recovery@cashbridge.in",
      FINANCE_MAIL_ID: "finance@cashbridge.in",
      SUPPORT_MAIL_ID: "support@cashbridge.in",
      KYC_URL: 'https://admin.cashbridge.in/kyc/',
      CONFIG_MAIL_ID: "config@cashbridge.in",
      RECOVERY_MAIL_ID:"recovery@cashbridge.in",
      APP_LINK:"app.cashbridge.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"Rachit Capital Services Privated Limited",
      ADDRESS:"Vipul Plaza, ",
      AREA:"Sector 81,",
      CITY :"Faridabad, Haryana - 121002"
    }

  },
  'admin.dreamsupporter.in': {
    COMPANY_NAME: "DreamSupporter",
    COMPANY_NAME_CAPS: "DREAMSUPPORTER",
    COMPANY_NAME_SMALLCASE: "dsfinance",
    FINANCE_URL:"https://finance.infitouch.in/",
    BASE_URL: 'https://backend.creditjar.in/',
    FRONTEND_BASE_URL: 'https://admin.dreamsupporter.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'ds',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.dreamsupporter.in/',
    TITLE: "Financing For Your Bright Future",
    FAVICON: dsFinanceFav,
    LOGO: DsFinanceLogo,
    LIGHT_LOGO: DsFinanceLogo,
     HEADER_LOGO_WIDTH: "80px",
     MSITE_URL: "",
    RootcssClassName: "Cashbridge-css",
    BOSS_EMAILID: "mohit.bansal@dsfinance.in",
    NBFC_NAME_TO_SHOW: "D.S. Finance",
    REPORT_DB_KEY: "creditjar",
    ADMIN_URL_STRING_SHORT :"dreamsupporter.in",
    ADMIN_URL_STRING_SHORT_FULL_URL :"admin.dreamsupporter.in",
     NBFC_SHORT:"DS Finance",
     WEBSITE_URL:"https://dsfinance.co.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : D.S.INTEGRATED FINSEC PRIVATE LIMITED ',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : RAJKOT - GONDAL ROAD',
      ACCOUNT_NUMBER: 'A/C : 072805003919',
      IFSC_CODE: 'ifsc code : ICIC0000728',
      NBFC_NAME:"D.S. Integrated Finsec Private Limited",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.dreamsupporter.in/uploadDocuments/",
      // MOBILE_NO: "+91-9220320064",
      MOBILE_NO: "9876543219",
      EMAIL_ID: "recovery@dsifpl.com",
      FINANCE_MAIL_ID: "finance@dsifpl.com",
      SUPPORT_MAIL_ID: "support@dsifpl.com",
      KYC_URL: 'https://admin.dreamsupporter.in/kyc/',
      CONFIG_MAIL_ID: "config@dsifpl.com",
      RECOVERY_MAIL_ID:"recovery@dsifpl.com",
      APP_LINK:"https://play.google.com/store/apps/details?id=com.dreamsupporter.dreamsupporterapp",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"D.S. Integrated Finsec Private Limited",
      ADDRESS:"OPP ANDH MAHILA VIKAS GRUH, ARIHANT,SHRAMJIVI SOCIETY,",
      AREA:" DHEBAR ROAD, RAJKOT,",
      CITY :"Rajkot, Gujarat, 360002"
    }
  },
  
};

const handleURL = () => {
  // const link = window.location?.host;
  // const link = "admin.credfin.money";
  // const link = "admin.abhicash.in";
  // const link = "admin.creditjar.in";
  // const link = "admin.cashbridge.in";
  const link = "admin.dreamsupporter.in";
  return link
}

const InvalidTenantPage = () => (
  <div style={{ padding: '2rem', textAlign: 'center', margin: '10% 15px' }}>
    <h1>Invalid URL</h1>
    <p>This domain is not configured for access. Please Contact the Developer</p>
  </div>
);

export const Company_DATA = {
  CREDFIN: "Credfin",
  ABHICASH: "Abhicash",
  CREDITJAR: "Creditjar",
  CASHBRIDGE: "Cashbridge",
  DREAMSUPPORTED: "DreamSupporter",
}

export const CheckFunction = () => {
  const url = handleURL();
  const tenantConfig = TENANT_CONFIGS[url]
  if (!tenantConfig) {

    return ""
  } 
  return tenantConfig
}


const MainFunction = () => {
  const dispatch = useDispatch()
  
  const url = handleURL();

  const tenantConfig = TENANT_CONFIGS[url]

  if (!tenantConfig) {

    return <InvalidTenantPage />;
  }

  dispatch({ type: 'SET_ACTIVE_TENANT', payload: tenantConfig });
  document.title = tenantConfig.TITLE || "";

  const rootElement = document.getElementById('phocketApp');
  if (rootElement) {
    rootElement.classList.add(tenantConfig?.RootcssClassName);
  }


  const favicon = document.querySelector('link[rel="shortcut icon"]') ||
    document.createElement('link');
  favicon.rel = 'icon';
  favicon.type = 'image/png';
  favicon.href = tenantConfig.FAVICON || "";
  if (!document.querySelector('link[rel="icon"]')) {
    document.head.appendChild(favicon);
  }


  return <Outlet />;

}

export default MainFunction;

export const CREDFIN_LIKE = [Company_DATA?.CREDFIN]
export const ABHICASH_ONLY = [Company_DATA?.ABHICASH]
export const ABHICASH_LIKE = [Company_DATA?.ABHICASH,Company_DATA?.CREDITJAR,Company_DATA?.CASHBRIDGE,Company_DATA?.DREAMSUPPORTED,Company_DATA?.WOGOM]
export const CREDITJAR_LIKE = [Company_DATA?.CREDITJAR]
export const CASHBRIDGE_LIKE = [Company_DATA?.CASHBRIDGE]
export const DREAM_SUPPORTER_LIKE = [Company_DATA?.DREAMSUPPORTED,Company_DATA?.WOGOM]
export const DREAM_SUPPORTER_ONLY = [Company_DATA?.DREAMSUPPORTED]



export const CHECK_COMPANY_TENANT = (arr)=>{
    const tenant = CheckFunction();
    if(arr?.includes(tenant?.COMPANY_NAME)){
      return true
    }
    return false
}